<template>
	<div id="container">
		<!-- 地图组件 -->
		<baidu-map class="map" :center="center" :zoom="12" id="mapContainer" v-show="!(addr_start_show || addr_end_show)">
			<!-- 头部标题 -->
			<Headerm v-bind:carRange="carRange"></Headerm>
			<!-- 定位点标注 -->
			<!-- <bm-marker
        :position="center"
        :dragging="true"
        animation="BMAP_ANIMATION_BOUNCE">
            </bm-marker>
       -->
			<!-- 线路规划 -->
			<bm-driving v-if="start_point.address && end_point.address" :start="start_point.location" :end="end_point.location"
			 :auto-viewport="true" :panel="false"></bm-driving>
			<!-- 显示规划信息 -->
			<bm-label v-if="chufatext && start_point.address" :content="chufatext" :position="start_point.location" :labelStyle="{color: '#000', fontSize : '14px',padding:'5px', border:'0px','box-shadow': '0px 0px 6px 0px #ccc'}"
			 title="" />
			<bm-label v-if="guihuatext && end_point.address" :content="guihuatext" :position="end_point.location" :labelStyle="{color: '#000', fontSize : '14px',padding:'5px', border:'0px','box-shadow': '0px 0px 6px 0px #ccc'}"
			 title="" />

			<!-- 地图视图 -->
			<bm-view style="width: 100%; height:100%; flex: 1;" :center="center"></bm-view>
			<!-- 底部 -->
			<div class="dibu">
				<!-- 选择地址 -->
				<div class="ipmain" v-show="buzhou==1">
					<div class="place-left">
						<div class="place-start">
							<span class="circle  text-red"></span><input type="text" readonly v-model="startpointtext" placeholder="请选择出发地"
							 @click="startClick" />
						</div>
						<div class="place-end">
							<span class="circle  text-blue"></span>
							<input type="text" readonly v-model="endpointtext" placeholder="请选择目的地" @click="endClick" />
						</div>
					</div>

				</div>
				<!-- 选择下单类型 -->
				<div class="xdmain" v-show="buzhou==2">
					<div class="otype" v-if="price && price.price">
						<div :class="['item',yctype==1?'active':'']" @click="changeYctype(1)">
							<p class="title">包车</p>
							<div class="icon"></div>
							<p class="priceall">预估<span class="deo">{{price.jsprice}}</span>元</p>
							<p class="trprice">￥<span class="pre">{{price.baoche.price}}</span></p>
							<p class="tishi">{{price.baoche.tishi}}</p>
						</div>
						<div :class="['item',yctype==0?'active':'']" @click="changeYctype(0)">
							<p class="title">拼车</p>
							<div class="icon"></div>
							<p class="priceall">预估<span class="deo">{{price.jsprice}}</span>元</p>
							<p class="trprice">￥<span class="pre">{{price.pinche.price}}</span></p>
							<p class="tishi">{{price.pinche.tishi}}</p>
						</div>
						<div :class="['item',yctype==2?'active':'']" @click="changeYctype(2)">
							<p class="title">寄货</p>
							<div class="icon"></div>
							<p class="priceall"></p>
							<p class="trprice">￥<span class="pre">{{price.jihuo.price}}</span></p>
							<p class="tishi">{{price.jihuo.tishi}}</p>
						</div>
					</div>
				</div>
				<!-- 选择下单属性-时间，人数乘坐类型 -->
				<div class="shuxin">
					<div class="item" @click="timeClick">{{timetext||'出发时间'}}<i class="iconnext"></i></div>
					<div class="item" @click="carClick">{{cartype.text||'乘坐类型'}}<i class="iconnext"></i></div>
					<div class="item" @click="personsClick">{{persons.text||'选择人数'}}<i class="iconnext"></i></div>
				</div>
				<!-- 下一步按钮 -->
				<div class="xiadanbtn" v-if="buzhou==1">
					<div class="btn" @click="nextClick">下一步</div>

				</div>
				<div class="xiadanbtn" v-if="buzhou==2">
					<div class="btn" @click="fristClick" style="flex-grow:1;background-color:#aaa;font-size:14px;">上一步</div>
					<div class="btn" style="flex-grow:5" @click="subClick">提交订单</div>

				</div>
			</div>
			<!-- 地图定位到当前位置视野 -->
			<!-- <bm-geolocation
        anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
        :showAddressBar="true"
        :autoLocation="true"
      ></bm-geolocation> -->
		</baidu-map>
		<!-- 选择起点-组件 -->
		<Addr v-show="addr_start_show" @selectChange="selectChangeStart"  discount="0" ref="refaddrstart"></Addr>
		<!-- 选择终点-组件 -->
		<Addr v-show="addr_end_show" @selectChange="selectChangeEnd"  discount="0" ref="refaddrend"></Addr>
		<!-- 时间控件 -->
		<div style="display:none">
			<yd-cell-item arrow>
				<span slot="left"></span>
				<yd-datetime type="datetime" :start-date="yddatetime.start_date" :end-date="yddatetime.end_date" :callback="selectChangeDate"
				 ref="datetime" v-model="yddatetime.time" slot="right"></yd-datetime>
			</yd-cell-item>
		</div>
		<!-- 车型选择控件 -->
		<yd-actionsheet :items="carsheetdata" v-model="show_carsheet" cancel="取消"></yd-actionsheet>
		<!-- 人数选择控件 -->
		<yd-actionsheet :items="cartype.key==1?persons7sheetdata:personssheetdata" v-model="show_personssheet" cancel="取消"></yd-actionsheet>
		<!-- 姓名电话输入框 -->
		<yd-popup v-model="user.usershow" position="center" width="90%" masker-opacity=".9" :close-on-masker="false">
			<div id="order-confirm" style="position:relative;">
				<img id="order-close" @click="hiddenTakeOrder" src="../assets/images/close.png" />
				<div id="confim-head">
					<div>提交信息，立即下单</div>
					<div>为了更有效的进行约车服务，请您准确填写以下信息</div>
				</div>
				<div id="confim-main">

					<yd-cell-group>
						<yd-cell-item>
							<span slot="left"><img src="../assets/images/person.png" style="width:0.33rem;"></span>
							<yd-input slot="right" required type="text" v-model="user.username" placeholder="请输入姓名"></yd-input>
						</yd-cell-item>

						<yd-cell-item>
							<span slot="left"><img src="../assets/images/mobile.png"></span>
							<yd-input slot="right" required type="text" regex="mobile" v-model="user.mobile" placeholder="请输入手机号"></yd-input>
						</yd-cell-item>
					</yd-cell-group>

					<yd-button-group>
						<yd-button size="large" @click.native="createOrder" id="sub-btn">立即提交</yd-button>

					</yd-button-group>

				</div>
			</div>
		</yd-popup>

		<yd-popup v-model="havingshow" position="center" width="80%" masker-opacity=".7" :close-on-masker="false">
			<div style="background-color:#fff; padding:0.3rem;">
				<div id="hacing-img"><img src="../assets/images/having.png"></div>
				<div id="having-title">{{havingmsg}}</div>
				<div id="having-con">是否进入？您可以从 “我的行程” 中查看。</div>
				<div id="having-btn">
					<yd-button size="large" type="hollow" @click.native="havingshow=false">不进入</yd-button>
					<yd-button size="large" type="primary" @click.native="toTripitem" style="background-color: #0480e8;margin-left:0.2rem;">去查看</yd-button>
				</div>

			</div>
		</yd-popup>
		<Subscribe></Subscribe>
	</div>
</template>

<script>
	import Headerm from "@/components/Headerm";
	import wx from "weixin-js-sdk";
	import Addr from "@/components/Addr";
	import Subscribe from "@/components/Subscribe";
	export default {
		components: {
			Headerm: Headerm,
			Addr: Addr,
			Subscribe: Subscribe
		},
		data() {
			return {
				clientHeight: document.documentElement.clientHeight,
				carRange: "outcity", //城际约车
				buzhou: 1,
				center: {
					lng: 0,
					lat: 0
				},
				addr_start_show: false,
				addr_end_show: false,
				start_point: {
					city: "",
					area: "",
					address: "",
					location: {}
				},
				end_point: {
					city: "",
					area: "",
					address: "",
					location: {}
				},
				yddatetime: {
					start_date: "",
					end_date: "",
					time: "",
					click: false
				},
				cartype: {
					text: "",
					key: 0
				},
				persons: {
					text: "",
					key: 1
				},
				price: {
					price: 0
				},
				yctype: 0,
				user: {
					username: "",
					mobile: "",
					usershow: false
				},
				show_carsheet: false,
				carsheetdata: [{
						label: "5坐小轿车",
						callback: () => {
							this.cartype = {
								text: "5坐小轿车",
								key: 0
							};
							this.clearPersons();
							this.personsClick();
						}
					},
					{
						label: "7坐商务车",
						callback: () => {
							this.cartype = {
								text: "7坐商务车",
								key: 1
							};
							this.clearPersons();
							this.personsClick();
						}
					}
				],
				show_personssheet: false,
				personssheetdata: [{
						label: "1人",
						callback: () => {
							this.persons = {
								text: "1人",
								key: 1
							};
						}
					},
					{
						label: "2人",
						callback: () => {
							this.persons = {
								text: "2人",
								key: 2
							};
						}
					},
					{
						label: "3人",
						callback: () => {
							this.persons = {
								text: "3人",
								key: 3
							};
						}
					},
					{
						label: "4人",
						callback: () => {
							this.persons = {
								text: "4人",
								key: 4
							};
						}
					}
				],
				persons7sheetdata: [{
						label: "1人",
						callback: () => {
							this.persons = {
								text: "1人",
								key: 1
							};
						}
					},
					{
						label: "2人",
						callback: () => {
							this.persons = {
								text: "2人",
								key: 2
							};
						}
					},
					{
						label: "3人",
						callback: () => {
							this.persons = {
								text: "3人",
								key: 3
							};
						}
					},
					{
						label: "4人",
						callback: () => {
							this.persons = {
								text: "4人",
								key: 4
							};
						}
					},
					{
						label: "5人",
						callback: () => {
							this.persons = {
								text: "5人",
								key: 5
							};
						}
					},
					{
						label: "6人",
						callback: () => {
							this.persons = {
								text: "6人",
								key: 6
							};
						}
					}
				],
				havingshow: false,
				havingdata: {}, //进行中的订单数据
				havingmsg: "您有行程在进行中"
			};
		},

		computed: {
			startpointtext: function() {
				// console.log(this.start_point);
				if (this.start_point.city && this.start_point.area) {
					return (
						this.start_point.city +
						" " +
						this.start_point.area +
						" " +
						this.start_point.address
					);
				} else {
					return "";
				}
			},
			endpointtext: function() {
				// console.log(this.end_point);
				if (this.end_point.city && this.end_point.area) {
					return (
						this.end_point.city +
						" " +
						this.end_point.area +
						" " +
						this.end_point.address
					);
				} else {
					return "";
				}
			},
			timetext: function() {
				return this.timeFormat(this.strtoTime(this.yddatetime.time), "dd日hh:mm");
			},
			chufatext: function() {
				if (this.yddatetime.time && this.price.price) {
					return this.timeFormat(
						this.strtoTime(this.yddatetime.time),
						"hh:mm出发"
					);
				} else {
					return "";
				}
			},
			guihuatext: function() {
				if (this.price && this.price.price) {
					return (
						this.price.distance + "公里，预计行车" + this.price.duration + "分钟"
					);
				} else {
					return "";
				}
			},
			having_order_show: function() {
				return this.$store.getters.getStateHavingOrderShow;
			}
		},
		created() {
			this.initJsSdk();
			this.initTime();
			this.getHavingdata();
		},
		mounted() {
			document.getElementById("mapContainer").style.height =
				this.clientHeight + "px";
			var user = this.getOrderUser();
			// console.log(user);
			this.user.username = user.username;
			this.user.mobile = user.mobile;
		},
		watch: {
			cartype: function() {
				// console.log("座位类型变化");
				this.computeMoney();
			},
			persons: function() {
				// console.log("人数变化");
				this.computeMoney();
			}
		},
		methods: {
			startClick: function() {
				this.addr_start_show = true;
			},
			endClick: function() {
				if (this.start_point.city == "" || this.start_point.area == "") {
					return;
				}
				this.addr_end_show = true;
			},
			timeClick: function() {
				this.$refs.datetime.open();
				this.yddatetime.click = true;
			},
			personsClick: function() {
				this.show_personssheet = true;
			},
			carClick: function() {
				this.show_carsheet = true;
			},
			nextClick: function() {
				if (this.price && this.price.price) {
					this.buzhou = 2;
				}
			},
			fristClick: function() {
				this.buzhou = 1;
			},
			subClick: function() {
				this.user.usershow = true;
			},
			selectChangeStart: function(ret) {
				// console.log(ret);
				this.start_point.city = ret.city;
				this.start_point.area = ret.county;
				this.start_point.address = ret.address;
				this.start_point.location = ret.location;
				this.addr_start_show = false;
				this.$refs.refaddrend.getlinelist(ret.city, ret.county);
				this.clearEndPoint();
				this.clearPrice();
			},
			selectChangeEnd: function(ret) {
				// console.log(ret);
				this.end_point.city = ret.city;
				this.end_point.area = ret.county;
				this.end_point.address = ret.address;
				this.end_point.location = ret.location;
				this.addr_end_show = false;
				this.clearPrice();
				this.computeMoney();
				this.timeClick();
			},
			selectChangeDate: function(res) {
				// console.log(res);
				this.yddatetime.click && this.carClick();
			},
			changeYctype: function(type) {
				this.yctype = type;
			},
			clearStartPoint: function() {
				this.start_point = {
					city: "",
					area: "",
					address: "",
					location: {}
				};
			},
			clearPersons: function() {
				this.persons = {
					text: "",
					key: 1
				};
			},
			clearEndPoint: function() {
				this.end_point = {
					city: "",
					area: "",
					address: "",
					location: {}
				};
			},
			clearPrice: function() {
				this.price = {
					price: 0
				};
			},
			clearOrderData: function() {
				this.clearEndPoint();
				this.clearPersons();
				this.yddatetime.click = false;
				this.yddatetime.time = "";
				this.cartype = {
					text: "",
					key: 0
				};
				this.clearPrice();
				this.yctype = 0;
				this.buzhou = 1;
			},
			hiddenTakeOrder: function() {
				this.user.usershow = false;
			},
			initJsSdk: function() {
				var that = this;
				this.$ajax({
						method: "get",
						url: "Weixin/create_js_config",
						data: {}
					})
					.then(response => {
						if (response.data.errno == 0) {
							wx.config({
								debug: false,
								appId: "" + response.data.data.appid, // 必填，公众号的唯一标识
								timestamp: response.data.data.timestamp, // 必填，生成签名的时间戳
								nonceStr: "" + response.data.data.noncestr, // 必填，生成签名的随机串
								signature: "" + response.data.data.signature, // 必填，签名
								jsApiList: ["getLocation", "updateAppMessageShareData"] // 必填，需要使用的JS接口列表
							});
							wx.ready(function() {
								wx.checkJsApi({
									jsApiList: ["getLocation"],
									success: function(res) {
										if (res.checkResult.getLocation == false) {
											alert(
												"你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！"
											);
											return;
										}
									}
								});
								wx.error(function(res) {
									console.log("微信出错");
								});
								that.getWxLocation();
							});
						} else {
							that.getIpLocation();
							console.log(response.data);
						}
					})
					.catch(function(err) {
						console.log(err);
					});
			},
			getWxLocation: function() {
				var that = this;
				wx.getLocation({
					success: function(res) {
						console.log('定位', res);
						if (res.errMsg == "getLocation:ok") {
							that.centerZuoBiaoZhuan(res.latitude, res.longitude);
							that.getLineByPosition(res.latitude, res.longitude, 1);
						} else {
							console.log("微信获取位置失败", res);
							that.getIpLocation();
						}
					},
					cancel: function(res) {
						//alert('用户拒绝授权获取地理位置');
					}
				});
			},
			getIpLocation: function() {
				var that = this;
				this.$ajax({
						method: "post",
						url: "Index/location_ip",
						data: {}
					})
					.then(result => {
						console.log(result.data);
						if (result.data.errno == 0) {
							this.center = result.data.data;
							that.getLineByPosition(this.center.lat, this.center.lng, 0);
						}
					})
					.catch(function(err) {
						alert("出错了");
					});
			},
			getLineByPosition: function(latitude, longitude, poszhan) {
				this.$ajax({
						method: "post",
						url: "Index/getLineByPosition",
						data: {
							latitude: latitude,
							longitude: longitude,
							poszhan: poszhan
						}
					})
					.then(res => {
						// console.log(res);
						//查看数据库中是否有路线
						if (res.data.errno == 0) {
							this.start_point.area = res.data.data.line.start_area;
							this.start_point.city = res.data.data.line.start_city;
							this.start_point.address = res.data.data.addr.sematic_description;
							this.start_point.location = {
								lat: latitude,
								lng: longitude
							};
							this.$refs.refaddrend.getlinelist(
								this.start_point.city,
								this.start_point.area
							);
							this.clearEndPoint();
						} else {
							//沒有路线就不设置
							//给出提示
							this.$dialog.toast({
								mes: "该地区路线暂未开通",
								timeout: 1500,
								icon: "error",
								callback: () => {
									console.log("错误:" + res.data.errmsg);
								}
							});
						}
					})
					.catch(function(err) {
						console.log("根据定位查询线路接口出错了", err);
					});
			},
			//动态设置金额和积分
			computeMoney: function() {
				if (
					!(
						this.start_point.city &&
						this.start_point.area &&
						this.end_point.city &&
						this.end_point.area &&
						this.end_point.location.lat &&
						this.start_point.location.lat
					)
				) {
					return;
				}
				this.$ajax({
						method: "post",
						url: "line/getPrice",
						data: {
							yctype: this.yctype,
							start_city: this.start_point.city,
							start_area: this.start_point.area,
							end_city: this.end_point.city,
							end_area: this.end_point.area,
							persons: this.persons.key,
							cartype: this.cartype.key,
							slatitude: this.start_point.location.lat,
							slongitude: this.start_point.location.lng,
							elatitude: this.end_point.location.lat,
							elongitude: this.end_point.location.lng
						}
					})
					.then(response => {
						if (response.data.errno == 0) {
							// console.log(response.data.data);
							this.price = response.data.data;
						} else {
							// console.log(response.data.errmsg);
							this.$dialog.toast({
								mes: response.data.errmsg,
								timeout: 1500,
								icon: "error",
								callback: () => {}
							});
						}
					})
					.catch(function(err) {
						console.log("计算价格出错啦！");
					});
			},
			initTime: function() {
				//处理年度交接的时候比如2019的最后15天要允许出现2020
				this.yddatetime.start_date = this.timeFormat(
					Date.parse(new Date()) / 1000 + 20 * 60
				);
				this.yddatetime.end_date = this.timeFormat(
					Date.parse(new Date()) / 1000 + 60 * 60 * 24 * 3
				);
				this.yddatetime.time = this.timeFormat(
					Date.parse(new Date()) / 1000 + 20 * 60
				);
			},
			createOrder: function() {
				if (!this.user.username || !this.user.mobile) {
					this.$dialog.toast({
						mes: "请输入手机号和姓名",
						timeout: 1500
					});
					return;
				}
				this.$dialog.loading.open("订单提交中...");
				this.$ajax({
						method: "post",
						url: "Index/yueche_v2",
						data: {
							lineid: this.price.lineid,
							yctype: this.yctype,
							persons: this.persons.key,
							depart_time: this.yddatetime.time,
							cartype: this.cartype.key,
							username: this.user.username,
							mobile: this.user.mobile,
							start_city: this.start_point.city,
							start_area: this.start_point.area,
							start_address: this.start_point.address,
							end_city: this.end_point.city,
							end_area: this.end_point.area,
							end_address: this.end_point.address,
							slatitude: this.start_point.location.lat,
							slongitude: this.start_point.location.lng,
							elatitude: this.end_point.location.lat,
							elongitude: this.end_point.location.lng,
							driverid: this.getAutoDriver()
						}
					})
					.then(response => {
						this.$dialog.loading.close();
						// console.log(response.data.data);
						if (response.data.errno == 0) {
							//保存本地下单名字和电话号码
							this.setOrderUser(this.user.username, this.user.mobile);
							this.$dialog.toast({
								mes: response.data.errmsg,
								timeout: 1500,
								icon: "success"
							});
							this.setAutoDriver(0);
							this.clearOrderData();
							this.hiddenTakeOrder();
							if (response.data.data.payway == 1) {
								//微信支付
								this.requestPaymentH5(
									response.data.data.paydata,
									response.data.data.orderid
								);
							} else {
								//现金支付
								this.$router.push({
									path: "/mytripitem",
									query: {
										itemid: response.data.data.orderid
									}
								});
							}
						} else {
							this.$dialog.toast({
								mes: response.data.errmsg,
								timeout: 1500,
								icon: "error"
							});
						}
					})
					.catch(function(err) {
						console.log(err);
					});
			},
			requestPaymentH5: function(data, orderid) {
				var that = this;
				wx.chooseWXPay({
					timestamp: data.timeStamp + "", // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
					nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
					package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
					signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
					paySign: data.sign, // 支付签名
					success: function(ret) {
						// 支付成功后的回调函数
						if (ret.errMsg == "chooseWXPay:ok") {
							that.$router.push({
								path: "/mytripitem",
								query: {
									itemid: orderid
								}
							});
						} else {
							console.log(ret);
						}
					}
				});
			},
			getHavingdata() {
				//获取进行中的订单数据
				if (this.having_order_show) {
					//请示状态树是否允许显示
					this.$ajax({
							method: "post",
							url: "Index/having"
						})
						.then(result => {
							console.log(result.data);
							if (result.data.errno == 0) {
								this.havingshow = true;
								this.havingdata = result.data.data;
								this.$store.commit("setStateHavingOrderShow", false);
							}
						})
						.catch(function(err) {
							alert("出错了");
						});
				} else {
					console.log(this.having_order_show);
				}
			},
			toTripitem() {
				if (this.havingdata.id) {
					this.havingshow = false;
					this.$router.push({
						path: "/mytripitem",
						query: {
							itemid: this.havingdata.id
						}
					});
				} else {
					this.$dialog.toast({
						mes: "程序繁忙请刷新",
						timeout: 1500,
						icon: "error"
					});
				}
			},
			centerZuoBiaoZhuan: function(latitude, longitude) {
				this.$ajax({
						method: "post",
						url: "Index/geoconv",
						data: {
							latitude: latitude,
							longitude: longitude
						}
					})
					.then(result => {
						// console.log(result.data);
						if (result.data.errno == 0) {
							this.center = result.data.data;
						}
					})
					.catch(function(err) {
						alert("出错了");
					});
			}
		}
	};
</script>
<style scoped>
	.map {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.ipmain {
		width: 88%;
		margin-left: 6%;
	}

	.dibu {
		height: 200px;
	}

	.place-left {
		width: 100%;
		display: inline-block;
		padding: 0.1rem 0;
	}

	.place-left input {
		width: 94%;
		display: inline-block;
		border: none;
		padding: 0.29rem 0;
		font-size: 0.3rem;
		padding-left: 0.2rem;
	}

	.place-left .place-start input:nth-child(2) {
		color: #000;
		border-bottom: 1px solid #eeeeee;
	}

	.place-left .place-start input:nth-child(3) {
		width: 52%;
		border-bottom: 1px solid #eeeeee;
		padding-left: 0.15rem;
	}

	.place-left .place-end input:nth-child(2) {
		color: #000;
		border-bottom: 1px solid #eeeeee;
	}

	.place-left .place-end input:nth-child(3) {
		width: 52%;
		padding-left: 0.15rem;
		border-bottom: 1px solid #eeeeee;
	}

	.circle {
		display: inline-block;
		border-radius: 50%;
		height: 0.72rem;
		line-height: 0.72rem;
		margin-right: 0.15rem;
		width: 0.13rem;
		height: 0.13rem;
	}

	.text-blue {
		background-color: #0689f7;
	}

	.text-red {
		background-color: #ff1b1b;
	}

	.shuxin {
		width: 100%;
		display: flex;
		flex-direction: row;
		height: 35px;
		line-height: 35px;
		margin-bottom: 5px;
	}

	.shuxin .item {
		flex-grow: 1;
		text-align: center;
		color: #444;
		display: flex;
		justify-content: center;
		font-size: 14px;
	}

	.shuxin .item .iconnext {
		width: 15px;
		height: 35px;
		display: inline-block;
		background-image: url("../assets/images/getinto.png");
		background-position: center;
		background-size: 8px 14px;
		background-repeat: no-repeat;
		line-height: 35px;
	}

	.xiadanbtn {
		width: 100%;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: center;
	}

	.xiadanbtn .btn {
		background-color: #0689f7;
		height: 40px;
		color: #fff;
		line-height: 40px;
		font-size: 17px;
		text-align: center;
		flex-grow: 1;
		border-radius: 5px;
		margin-left: 0.2rem;
		margin-right: 0.2rem;
	}

	.xdmain {
		width: 100%;
	}

	.otype {
		width: 100%;
		display: flex;
		margin-bottom: 0.1rem;
		flex-direction: row;
		justify-content: space-around;
	}

	.otype .item {
		/* flex-grow: 1; */
		width: 33%;
		height: 110px;
		/* background-color: #0689f7; */
		text-align: center;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		padding-top: 5px;
		padding-bottom: 5px;
	}

	.otype .active {
		box-shadow: 0px 0px 6px 0px #ccc;
	}

	.otype .item .title {
		width: 100%;
		text-align: center;
		line-height: 25px;
		font-size: 15px;
	}

	.otype .item .icon {
		height: 35px;
		background-image: url("../assets/images/five_seat_car.png");
		background-position: center;
		background-size: 50%;
		background-repeat: no-repeat;
	}

	.otype .item .priceall {
		line-height: 18px;
		font-size: 12px;
		color: #555;
	}

	.otype .item .tishi {
		line-height: 18px;
	}

	.otype .item .priceall .deo {
		text-decoration: line-through;
	}

	.otype .item .trprice {
		line-height: 18px;
		color: #ff1b1b;
	}

	.otype .item .trprice .pre {
		font-size: 14px;
		font-weight: 700;
	}

	#take-order {
		background-color: #0480e8;
		width: 6.9rem;
		color: #fff;
		text-align: center;
		font-size: 0.4rem;
		margin-top: 0.8rem;
		margin-left: -0.2rem;
	}

	#order-confirm {
		width: 100%;
		height: 7.6rem;
		background-image: url("../assets/images/order-bg.png");
		background-repeat: no-repeat;
		background-size: 100%;
		padding: 1.58rem 0.3rem 0 0.3rem;
		z-index: 1600;
	}

	#order-confirm #order-close {
		width: 0.19rem;
		height: 0.19rem;
		position: absolute;
		top: 0.95rem;
		right: 0.2rem;
	}

	#order-confirm #confim-head {
		width: 100%;
		text-align: center;
		letter-spacing: 0.024rem;
		font-family: PingFang-SC-Regular;
	}

	#order-confirm #confim-head div:nth-child(1) {
		font-size: 0.34rem;
		color: rgba(255, 255, 255, 1);
	}

	#order-confirm #confim-head div:nth-child(2) {
		font-size: 0.24rem;
		padding: 0.13rem 0 0.4rem 0;
		color: rgba(255, 255, 255, 1);
		opacity: 0.4;
	}

	#order-confirm #confim-main {
		width: 100%;
		text-align: center;
		background-color: rgba(255, 255, 255, 1);
		border-radius: 2%;
		padding: 0.23rem;
	}

	#order-confirm #confim-main #sub-btn {
		height: 0.8rem;
		border-radius: 0.06rem;
		background-color: #0480e8;
		margin-bottom: 0.4rem;
	}

	#order-confirm #confim-main span {
		display: inline-block;
		padding-right: 0.3rem;
	}

	#order-confirm #confim-main img {
		height: 0.44rem;
		width: 0.3rem;
	}

	#order-confirm #confim-main .yd-input {
		font-size: 0.4rem;
		color: red;
	}

	#complaint {
		text-align: center;
		position: absolute;
		bottom: 0.3rem;
		left: 3.14rem;
		top: 11rem;
	}

	#complaint img {
		height: 0.28rem;
		width: 1.23rem;
	}

	#hacing-img {
		text-align: center;
	}

	#hacing-img img {
		width: 1.6rem;
		height: 1.6rem;
	}

	#having-title {
		font-size: 0.38rem;
		text-align: center;
		padding: 0.3rem 0;
	}

	#having-con {
		font-size: 0.34rem;
		text-align: left;
		padding: 0 0.2rem;
		color: #666;
	}

	#having-btn {
		text-align: center;
	}

	#having-btn button {
		text-align: center;
		width: 45%;
		display: inline-block;
	}
</style>



// WEBPACK FOOTER //
// src/views/Map.vue